import React from 'react';
import { Box } from '@mui/material';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import WhatWeDo from './components/WhatWeDo';
import HowItHelps from './components/HowItHelps';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <Box>
      <Header />
      <Hero />
      <About />
      <WhatWeDo />
      <HowItHelps />
      <Contact />
      <Footer />
    </Box>
  );
}

export default App;

